import { Button, Typography } from "@suraasa/placebo-ui"
import CpatLogo from "features/Cpat/assets/cpat-mini-logo.webp"
import { useGlobalContext } from "global/Context/context"
import { Link } from "react-router-dom"
import routes from "routes"
import { useEnrollments } from "utils/hooks/useEnrollments"

const CpatBanner = () => {
  const {
    cpat: { hasCpat, hasCompletedCpat },
  } = useEnrollments()
  const { isNcte } = useGlobalContext()

  if (!hasCpat) return null

  return (
    <div className="mb-4.5 flex flex-col  rounded-[16px] bg-[#E9E0FA] p-2">
      <Typography
        variant="smallBody"
        className="text-[12px] font-semibold text-decorative-two-100"
      >
        ASSESSMENT
      </Typography>
      <div className="mt-0.5 rounded-[12px] bg-white p-2.5">
        <div className="flex flex-row justify-between gap-3">
          <div className="flex flex-col">
            <Typography variant="title3" className="mb-1.5">
              {isNcte
                ? "National Council for Teacher Education Assessment"
                : "Comprehensive Pedagogy Assessment of Teachers"}
            </Typography>
            {!hasCompletedCpat && (
              <Typography variant="smallBody" className="text-onSurface-500">
                Your CPAT journey begins here. Head to the dashboard to view the
                format and instructions. Attempt the assessment whenever
                you&apos;re ready.
              </Typography>
            )}
            {hasCompletedCpat && (
              <Typography variant="smallBody" className="text-onSurface-500">
                Congratulations! You have completed the CPAT Assessment. Head to
                the dashboard to view your reports and insights.
              </Typography>
            )}
          </div>
          <img src={CpatLogo} alt="" className="size-4.5" />
        </div>
        <div className="h-3"></div>
        <Link to={routes.cpat.dashboard}>
          <Button color="black">Open Dashboard</Button>
        </Link>
      </div>
    </div>
  )
}

export default CpatBanner
